import React from "react";
import { useParams } from "react-router-dom";
import { useGetPageUrl } from "../utils/use-get-page-url";
import { Button } from "@/components/ui/button";

export const ThemesHelperMenuItem: React.FC = () => {
  const { organizationId } = useParams();
  const { getThemesUrl } = useGetPageUrl();

  const openThemesPopup = React.useCallback(() => {
    if (!organizationId) {
      return;
    }

    window.open(
      getThemesUrl({ organizationId }),
      "",
      "menubar=0,resizable=1,width=750,height=550,left=200,top=100"
    );
  }, [organizationId]);

  if (!organizationId) {
    return null;
  }
  return (
    <Button variant="ghost" size="sm" onClick={openThemesPopup}>
      Themes
    </Button>
  );
};
